import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from 'primereact/dialog'
import { Checkbox } from 'primereact/checkbox'
import { Messages } from 'primereact/messages'
import ButtonComponent from '../ButtonComponent'

const ReportColumnSettingsDialog = ({ visible, onHide, columns = [], activeCheckBox = {}, onCheckboxChange, onSubmit, disableSubmit, messagesRef, columnsFilter }) => {
  const { t } = useTranslation()

  const columnsToShow = typeof columnsFilter === 'function' ? columns.filter(columnsFilter) : columns

  useEffect(() => {
    if (messagesRef?.current && visible) {
      messagesRef.current.clear()
      if (disableSubmit) {
        messagesRef.current.show([
          {
            sticky: true,
            severity: 'info',
            summary: 'Info : ',
            detail: t('YOU_NEED_TO_SELECT_MINIMUM_OF_4_COLUMNS'),
            closable: false
          }
        ])
      }
    }
  }, [disableSubmit, visible, t, messagesRef])

  return (
    <Dialog header={t('SETTINGS')} visible={visible} className="setting-dialog-modal" onHide={onHide}>
      <div className="columns-container">
        {columnsToShow.map((column) => (
          <div key={column.dataField} className="column">
            <Checkbox inputId={column.dataField} name="column" value={column.dataField} checked={!!activeCheckBox[column.dataField]} onChange={(e) => onCheckboxChange(column, e)} />
            <label htmlFor={column.dataField} className="column-name">
              {column.text}
            </label>
          </div>
        ))}
      </div>
      {disableSubmit && <Messages className="info-message" ref={messagesRef} />}
      <div className="setting-button-container">
        <div className={`submit-button-wrapper ${disableSubmit ? 'disable-text-present' : ''}`}>
          <ButtonComponent type="Custom" label="Submit" variant="action" disabled={disableSubmit} onClick={onSubmit} />
        </div>
      </div>
    </Dialog>
  )
}

export default ReportColumnSettingsDialog
